import {

    GetAllDropDownsForCPASMember,
    GetAllCPASMembersList,
    GetCPASMemberDetailByMemberId,
    StoreBase64Image,
    CPASMemberSignUp,
    AddEditCPASEducationalQualifications,
    AddEditCPASProfessionalQualifications,
    AddEditCPASProfessionalQualificationIfApplicable,
    DeleteCpasProfessionalIfApplicableQualifications,
    DeleteCpasProfessionalQualifications,
    AddEditCPASEmploymentHistory,
    DeleteCpasEmploymentHistory,
    AddEditCPASProjectCitedInReport,
    DeleteCpasProjectCitedInReport,
    GetCPASEducationInformationList,
    GetCPASProfessionalQualificationsList,
    GetCPASProfessionalQualificationIfApplicable,
    GetCPASEmploymentHistory,
    GetCPASProjectCitedInReport,
    UploadPdf,
    DeleteCpasEducationalInformation,
    UpdateSecretariatAndPreAssessmentStatus,
    SendClarificationForSecretariatAndPreAssessment,
    GetCPASMemberFiles,
    AddEditCPASScoringSheet,
    SendRejectionMailToSecretariatAndPreAssessment,
    SendForPreAssessmentSecretariatReviewMail,
    GetCpasInterviewApplicantList,
    AssignCPASInterview,
    GetCPASScoringSheetDetailById,
    GetCPASInterviewDetailsByBatchId,
    AddInterviewAssesorDetail,
    AddInterviewPackageList,
    AcceptAndApproveCpasMember,
    DownloadCPASMultipleZipFiles,
    RejectCpasMember,
    RejectAppealCpasMember,
    GetAllCPDClaimApprovalList,
    DownloadWrittenReportTemplate,
    GetCPDClaimApprovalDetailsById,
    SearchApprovedCPASMemberList,
    ApprovedCPDPoints,
    GetCPASMemberCertificate,
    GetACPCPASRegistryList,
    DownloadSheetForCPASRegistryListReport,
    UpdateCpasStatusManually,
    DeleteCPASMember

} from "../ApiEndPoints";
import { axiosGet, axiosGetFileAuthorizeblob, axiosPost, axiosPostWithoutEncryption, axiosPostAuthorize, axiosPostFileAuthorizeblob } from "../AxiosRequests";

export default class CPASMemberServices {

    async downloadSheetForCPASRegistryListReport(request) {
        return axiosPostFileAuthorizeblob(DownloadSheetForCPASRegistryListReport, request);
    }
    async DownloadWrittenReportTemplate() {
        return axiosGet(DownloadWrittenReportTemplate);
    }
    async GetAllDropDownsForCPASMember() {
        return axiosGet(GetAllDropDownsForCPASMember);
    }
    async GetAllCPASMembersList(request) {
        return axiosPost(GetAllCPASMembersList, request);
    }
    async getACPCPASRegistryList(request) {
        return axiosPost(GetACPCPASRegistryList, request);
    }
    async GetCPASMemberDetailByMemberId(request) {
        return axiosGet(GetCPASMemberDetailByMemberId, request);
    }
    async GetCPASScoringSheetDetailById(request) {
        return axiosGet(GetCPASScoringSheetDetailById, request);
    }
    async storeBase64Image(request) {
        return axiosPostWithoutEncryption(StoreBase64Image, request, false);
    }
    async CPASMemberSignUp(request) {
        return axiosPost(CPASMemberSignUp, request);
    }
    async AssignCPASInterview(request) {
        return axiosPost(AssignCPASInterview, request);
    }
    async AddEditCPASEducationalQualifications(request) {
        return axiosPost(AddEditCPASEducationalQualifications, request);
    }
    async AddEditCPASProjectCitedInReport(request) {
        return axiosPost(AddEditCPASProjectCitedInReport, request);
    }
    async AddEditCPASProfessionalQualifications(request) {
        return axiosPost(AddEditCPASProfessionalQualifications, request);
    }
    async AddEditCPASProfessionalQualificationIfApplicable(request) {
        return axiosPost(AddEditCPASProfessionalQualificationIfApplicable, request);
    }
    async deleteCpasProfessionalQualifications(request) {
        return axiosPost(DeleteCpasProfessionalQualifications, request)
    }
    async deleteCpasProfessionalIfApplicableQualifications(request) {
        return axiosPost(DeleteCpasProfessionalIfApplicableQualifications, request)
    }
    async deleteCpasEmploymentHistory(request) {
        return axiosPost(DeleteCpasEmploymentHistory, request)
    }
    async deleteCpasProjectCitedInReport(request) {
        return axiosPost(DeleteCpasProjectCitedInReport, request)
    }
    async AddEditCPASEmploymentHistory(request) {
        return axiosPost(AddEditCPASEmploymentHistory, request);
    }
    async getCPASEmploymentHistory(request) {
        return axiosGet(GetCPASEmploymentHistory, request);
    }
    async getCPASProfessionalQualificationsList(request) {
        return axiosGet(GetCPASProfessionalQualificationsList, request);
    }
    async getCPASProfessionalQualificationIfApplicable(request) {
        return axiosGet(GetCPASProfessionalQualificationIfApplicable, request);
    }
    async GetCPASInterviewDetailsByBatchId(request) {
        return axiosGet(GetCPASInterviewDetailsByBatchId, request);
    }
    async RejectCpasMember(request) {
        return axiosPost(RejectCpasMember, request);
    }

    async RejectAppealCpasMember(request) {
        return axiosGet(RejectAppealCpasMember, request);
    }
    async getCPASEducationInformationList(request) {
        return axiosGet(GetCPASEducationInformationList, request);
    }
    async getCPASProjectCitedInReport(request) {
        return axiosGet(GetCPASProjectCitedInReport, request);
    }
    async uploadPDF(request) {
        let formData = new FormData();
        formData.append("file", request.file);
        formData.append("filename", request.filename);
        formData.append("storagePath", request.storagePath);
        return axiosPostWithoutEncryption(UploadPdf, formData, true);
    }
    async UpdateSecretariatAndPreAssessmentStatus(request) {
        return axiosPost(UpdateSecretariatAndPreAssessmentStatus, request);
    }
    async DownloadCPASMultipleZipFiles(request) {
        return axiosPostFileAuthorizeblob(DownloadCPASMultipleZipFiles, request)
    }


    async AcceptAndApproveCpasMember(request) {
        return axiosPost(AcceptAndApproveCpasMember, request);
    }

    async SendClarificationForSecretariatAndPreAssessment(request) {
        return axiosPost(SendClarificationForSecretariatAndPreAssessment, request);
    }
    async deleteCpasEducationalInformation(request) {
        return axiosPost(DeleteCpasEducationalInformation, request)
    }
    async GetCPASMemberFiles(request) {
        return axiosGetFileAuthorizeblob(GetCPASMemberFiles, request);
    }
    async AddEditCPASScoringSheet(request) {
        return axiosPost(AddEditCPASScoringSheet, request);
    }

    async SendRejectionMailToSecretariatAndPreAssessment(request) {
        return axiosPost(SendRejectionMailToSecretariatAndPreAssessment, request);
    }
    async SendForPreAssessmentSecretariatReviewMail(request) {
        return axiosPost(SendForPreAssessmentSecretariatReviewMail, request);
    }
    async GetCpasInterviewApplicantList(request) {
        return axiosPost(GetCpasInterviewApplicantList, request);
    }
    async addInterviewAssesorDetail(request) {
        return axiosPost(AddInterviewAssesorDetail, request);
    }
    async getAllCPDClaimApprovalList(request) {
        return axiosPost(GetAllCPDClaimApprovalList, request);
    }
    async getCPDClaimApprovalDetailsById(request) {
        return axiosGet(GetCPDClaimApprovalDetailsById, request);
    }
    async searchApprovedCPASMemberList(request) {
        return axiosGet(SearchApprovedCPASMemberList, request);
    }
    async approvedCPDPoints(request) {
        return axiosPost(ApprovedCPDPoints, request);
    }

    async getCPASMemberCertificate(request) {
        return axiosGetFileAuthorizeblob(GetCPASMemberCertificate, request)
    }
    async updateCpasStatusManually(request) {
        return axiosPost(UpdateCpasStatusManually, request);
    }
    async deleteCPASMember(request) {
        return axiosPostAuthorize(DeleteCPASMember, request);
      }
}
